<template>
   <div class="section section-news" id="section-news" v-if="news != 0" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
        <div class="container">
            <div class="section-title">
                <h5>{{news.upper_title}}</h5>
                <h2>{{news.title}}</h2>
            </div>
            <div class="help-desc-mobile">
                <svg-icon icon-class="dragpan" className="icon-dragpan"/>
                <p>Вы можете листать по горизонтали</p>
            </div>
            <div class="news-items">
                <div class="news-item" v-for="(item, index) in news.news_items" :key="index">
                    <div class="news-circle">
                        <div class="circle-wrapper">
                            <div class="circle-item">
                                <svg viewBox="0 0 36 36" class="circular-chart">
                                    <path class="circle-bg"
                                        d="M18 2.0845
                                        a 15.9155 15.9155 0 0 1 0 31.831
                                        a 15.9155 15.9155 0 0 1 0 -31.831"
                                    />
                                    <path class="circle"
                                        :stroke-dasharray="item.ready_number + ',100'"
                                        d="M18 2.0845
                                        a 15.9155 15.9155 0 0 1 0 31.831
                                        a 15.9155 15.9155 0 0 1 0 -31.831"
                                    />
                                </svg>
                            </div>
                            <div class="number-activity" v-if="animate" :data-ready="item.ready_number">
                                <!-- <h4>{{item.ready_number}}</h4> -->
                                <h4>
                                     <animate-number 
                                        from="0" 
                                        :to="item.ready_number"
                                        duration="2000"  
                                        easing="easeOutQuad"
                                        :formatter="formatter"
                                    ></animate-number>
                                </h4>
                                <span>%</span>
                            </div>
                        </div>
                        <div class="news-circle-bottom-controls">
                            <div class="circle-title">
                                <h3>{{item.title}}</h3>
                                <!-- <h3 class="ready-title">Строительство <br>завершено</h3> -->
                            </div>
                            <div class="btn-open-news-info-modal">
                                <a href="#" class="btn btn-open-news-modal" 
                                    @click.prevent="openNewsModalInit(index)"
                                    :disabled="activity[index] == false" 
                                    >
                                    <svg-icon icon-class="plus" className="icon-plus"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Новостная модалка -->
            <modal name="news-modal" @before-close="beforeNewsModalClose" @closed="newsModalClosed" :transition="transitionName" :width="modalWidth" :height="modalHeight" :scrollable="true" id="news-modal" :class="partName">
                <div class="modal-content">
                    <button class="btn-close-news-modal" @click="closeNewsModal()"><svg-icon icon-class="close" className="icon-close"/></button>
                    <transition name="fade" v-if="loading">
                        <div class="news-loading-element">
                            <img src="@/assets/images/loader.gif" alt="">
                        </div>
                    </transition>
                    <div class="news-modal-content" :class="{notVisible: notVisible}">
                        <div class="col-left">
                            <div class="news-modal-top-titles">
                                <h4>{{news.news_modal_upper_title}}</h4>
                                <h3>{{news.news_modal_title}}</h3>
                                <h3 class="ready-title">1 очередь</h3>
                                <div class="desc">
                                    <p>{{news.news_modal_desc}}</p>
                                    <p class="ready-desc">Строительство завершено</p>
                                </div>
                            </div>
                            <!-- select month -->
                            <div class="news-modal-info-selection-item">
                                <select id="select-month" v-model="selected">
                                    <option :value="index" v-for="(item, index) in newsData" :key="index">
                                        {{item.news_modal_month}}
                                    </option>
                                </select>
                                {{selected}}
                                <svg-icon icon-class="calendar" className="icon-calendar"/>
                                <svg-icon icon-class="down-arrow" className="icon-down-arrow"/>
                            </div>
                            <!-- end select month -->
                            <div class="news-modal-info-list" v-if="visible">
                                <ul>
                                    <li v-for="(item, index) in newsData[valueOption].news_modal_list_info" :key="index">
                                        <p>{{item.desc}}</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="news-modal-info-desc" v-if="visible">
                                <p>{{newsData[valueOption].news_modal_list_desc}}</p>
                            </div>
                        </div>
                        <div class="col-right">
                            <div class="news-info-modal-carousel" v-if="visible">
                                <swiper :options="swiperOption">
                                    <swiper-slide 
                                        v-for="(slide, index) in newsData[valueOption].news_modal_gallery" :key="index"
                                        :style="'background-image:url(' + slide.url + ')'"
                                    >
                                    </swiper-slide>
                                </swiper>
                                <div class="swiper-controls">
                                    <div class="news-btn-prev slider-btn"><svg-icon icon-class="left-arrow" className="icon-left-arrow"/></div>
                                    <div class="news-btn-next slider-btn"><svg-icon icon-class="right-arrow" className="icon-right-arrow"/></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </modal>
        </div>
   </div>
</template>

<script>
    export default {
        name: 'News',
        components: {
        },
        data () {
            return {
                get: [
                    {
                        link: 'news_part_one'
                    },
                    {
                        link: 'news_part_two'
                    },
                    {
                        link: 'news_part_three'
                    }
                ],
                newsData: [],
                selected: '',
                valueOption: 0,
                visible: false,
                activity: [],
                loading: true,
                notVisible: true,
                animate: false,
                modalWidth: 1000,
                modalHeight: 'auto',
                transitionName: 'pop-out',
                partName: '',
                swiperOption: {
                    speed: 600,
                    observer: true,
                    observeParents: true,
                    spaceBetween: 20,
                    effect: 'slide',
                    navigation: {
                        nextEl: '.news-btn-next ',
                        prevEl: '.news-btn-prev',
                    }
                },
                intersectionOptions: {
                    rootMargin: '0px 0px 0px 0px',
                    threshold: [0.25,0.75]
                }
            }
        },
        computed: {
            news () {
                return this.$store.state.news
            }
        },
        methods: {
            onWaypoint ({ el, going, direction }) {
                if (this.$waypointMap.GOING_IN === going) {
                    el.classList.add('animated-active');
                    this.animate = true;
                }
            },
            formatter(num) {
                return num.toFixed();
            },
            checkActivity () {
                var i;
                for (i = 0; i < this.news.news_items.length; i++) {
                    this.activity.push(this.news.news_items[i].btn_activity);
                }
            },  
            openNewsModalInit(index) {
                var _self = this;
                this.partName = this.get[index].link;
                axios.get(window.url + window.GlobalLang + window.JsonUrl + this.get[index].link)
                .then((response) => {
                    if(response)
                    setTimeout(function(){
                        var select = $('#select-month'),
                            selectParent = $('.news-modal-info-selection-item');
                        select.selectric();
                        select.selectric({
                            onChange: function() {
                                _self.valueOption = $(this).val();
                            },
                            onOpen: function() {
                                selectParent.addClass('open');
                            },
                            onClose: function() {
                                selectParent.removeClass('open');  
                            }
                        });
                    },500);
                    setTimeout(function(){
                        _self.notVisible = false;
                        _self.loading = false;
                    },800);
                    this.visible = true;
                    this.newsData = [];
                    var i;
                    for (i = 0; i < response.data.length; i++) {
                        this.newsData.push(response.data[i].acf);
                    }
                });
                this.$modal.show('news-modal');
            },
            closeNewsModal() {
                this.$modal.hide('news-modal');
            },
            beforeNewsModalClose() {
                this.notVisible = true;
            },
            newsModalClosed() {
                this.loading = true;
                this.valueOption = 0;
            }
        },
        mounted () {
            this.$store.watch(
                (state) => state.news,
                (newValue) => {
                    if (newValue)
                    this.checkActivity();
                }
            )
        }
    } 
</script>

<style lang="scss" scoped>
    @import '@/styles/components/news/news.scss';
    @import '@/styles/components/news/news-modal.scss';
    @import '@/styles/components/animation/animation-news.scss';
    @import '@/styles/components/news/media/media-tablet-pro.scss';
</style>